function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

import * as React from "react";
import ClientDetail, { ColorHeader } from "../../clients/form/ClientDetail";
import { ClientType } from "../../ISchema";

var UserForm = function UserForm(props) {
  var _polizaEndorsementFor, _polizaEndorsementFor2, _polizaEndorsementFor3;

  var currentType = props.currentType,
      poliza = props.poliza,
      polizaEndorsementForm = props.polizaEndorsementForm,
      regions = props.regions,
      communes = props.communes,
      setPolizaEndorsementForm = props.setPolizaEndorsementForm;

  var onChangeSomeClient = function onChangeSomeClient(newClient, clientType) {
    if (clientType === ClientType.contratante) {
      var asegurado = _objectSpread({}, poliza.asegurado);

      var beneficiario = _objectSpread({}, poliza.beneficiario);

      return setPolizaEndorsementForm(_objectSpread(_objectSpread({}, polizaEndorsementForm), {}, {
        poliza_params: {
          contratante: _objectSpread(_objectSpread({}, poliza.contratante), newClient)
        }
      }));
    }

    if (clientType === ClientType.asegurado) {
      return setPolizaEndorsementForm(_objectSpread(_objectSpread({}, polizaEndorsementForm), {}, {
        poliza_params: {
          asegurado: _objectSpread(_objectSpread({}, poliza.asegurado), newClient)
        }
      }));
    }

    if (clientType === ClientType.beneficiario) {
      return setPolizaEndorsementForm(_objectSpread(_objectSpread({}, polizaEndorsementForm), {}, {
        poliza_params: {
          beneficiario: _objectSpread(_objectSpread({}, poliza.beneficiario), newClient)
        }
      }));
    }
  };

  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", {
    className: "row"
  }, /*#__PURE__*/React.createElement("div", {
    className: "col-md-12"
  }, currentType === "contratante" && /*#__PURE__*/React.createElement(ClientDetail, {
    title: "Contratante",
    showHeader: false,
    currentType: currentType,
    token: "",
    colorHeader: ColorHeader.Gray,
    user: (polizaEndorsementForm === null || polizaEndorsementForm === void 0 ? void 0 : (_polizaEndorsementFor = polizaEndorsementForm.poliza_params) === null || _polizaEndorsementFor === void 0 ? void 0 : _polizaEndorsementFor.contratante) || poliza.contratante,
    listRegions: regions,
    listComunas: communes,
    onChange: function onChange(newClient) {
      return onChangeSomeClient(newClient, ClientType.contratante);
    }
  }), currentType === "asegurado" && /*#__PURE__*/React.createElement(ClientDetail, {
    title: "Asegurado",
    showHeader: false,
    currentType: currentType,
    token: "",
    colorHeader: ColorHeader.Gray,
    user: (polizaEndorsementForm === null || polizaEndorsementForm === void 0 ? void 0 : (_polizaEndorsementFor2 = polizaEndorsementForm.poliza_params) === null || _polizaEndorsementFor2 === void 0 ? void 0 : _polizaEndorsementFor2.asegurado) || poliza.asegurado,
    listRegions: regions,
    listComunas: communes,
    onChange: function onChange(newClient) {
      return onChangeSomeClient(newClient, ClientType.asegurado);
    }
  }), currentType === "beneficiario" && /*#__PURE__*/React.createElement(ClientDetail, {
    title: "Beneficiario",
    showHeader: false,
    currentType: currentType,
    token: "",
    colorHeader: ColorHeader.Gray,
    listRegions: regions,
    user: (polizaEndorsementForm === null || polizaEndorsementForm === void 0 ? void 0 : (_polizaEndorsementFor3 = polizaEndorsementForm.poliza_params) === null || _polizaEndorsementFor3 === void 0 ? void 0 : _polizaEndorsementFor3.beneficiario) || poliza.beneficiario,
    listComunas: communes,
    onChange: function onChange(newClient) {
      return onChangeSomeClient(newClient, ClientType.beneficiario);
    }
  }))));
};

export default UserForm;